import { Translation } from "../model/Translation";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export const fetchTranslationExports = async () => {
  const response = await axiosInstance.get<ApiResponse<Translation[]>>("/api/translation/exports");
  return response.data.data;
};
